'use strict'

import Vue from 'vue'
import axios from '@kso/axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.baseURL || process.env.apiUrl || process.env.VUE_APP_API_URL || '',
  // timeout: 60 * 1000, // Timeout
  withCredentials: true // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (config.method === 'get') {
      if (!config.params) {
        config.params = {}
      }
      config.params._t = Date.now()
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response.data
  },
  function (error) {
    let errorType = 'NETWORK_ERROR'
    let errorContent = error
    try {
      errorContent = error.response.data
      if (errorContent) {
        errorType = 'SERVICE_ERROR'
        if (errorContent.code === 40100100 || errorContent.result === 'userNotLogin') {
          // alert('没登录')
        }
      }
    } catch (err) {}

    let formatError = {
      type: errorType,
      info: errorContent
    }

    error.detail = formatError
    return Promise.reject(error)
  }
)

let Plugin = {
  install: function (Vue, options) {
    Vue.axios = _axios
    window.axios = _axios
    Object.defineProperties(Vue.prototype, {
      axios: {
        get () {
          return _axios
        }
      },
      $axios: {
        get () {
          return _axios
        }
      }
    })
  }
}

Vue.use(Plugin)

export default Plugin
